import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from './auth'
import axios from 'axios'
import SignIn from './components/login/SignIn'
import SignUp from './components/login/SignUp'
import ResetEmail from './components/login/ResetEmail'
import ResetNew from './components/login/ResetNew'
import AdminDashboard from './components/admin/Dashboard'
import OrderDashboard from './components/order/Dashboard'

Vue.use(VueRouter)
const TOKEN_TTL = 3600

function requireAuth (to, from, next) {
  if (auth.loggedIn()) {
    next()
  } else {
    next({
      path: '/sign-in',
      query: { redirect: to.fullPath }
    })
  }
}

function requireAdminAuth (to, from, next) {
  if (auth.isAdmin()) {
    console.log('you are admin!')
    next()
  } else {
    console.log('you are NOT admin')
    next({
      path: '/orders',
      query: { redirect: to.fullPath }
    })
  }
}

function alreadyLogged (to, from, next) {
  if (auth.loggedIn()) {
    next({
      path: '/orders',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

axios.interceptors.request.use(function (config) {
  let token = auth.getToken()
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
    let date = new Date()
    let timeLeft = parseInt(auth.getExpTime() - (date.getTime() / 1000))
    // console.log('timeLeft', timeLeft, auth.getExpTime(), date.getTime() / 1000)
    if (timeLeft < TOKEN_TTL / 2) {
      auth.needRefresh()
    }
  }
  return config
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    router.push({ path: '/logout' })
  }
  return Promise.reject(error)
})

/* eslint-disable no-new */
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/orders'
    },
    {
      path: '/orders',
      component: OrderDashboard,
      beforeEnter: requireAuth
    },
    {
      path: '/sign-in',
      component: SignIn,
      beforeEnter: alreadyLogged
    },
    { path: '/sign-up', component: SignUp },
    { path: '/reset/:token', component: ResetNew },
    { path: '/reset', component: ResetEmail },
    {
      path: '/admin',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth
    },
    {
      path: '/admin/depots',
      name: 'tab-0',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: { activeTab: 0 }
    },
    {
      path: '/admin/depots/form',
      name: 'tab-0-create',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: { activeTab: 0, create: 0 }
    },
    {
      path: '/admin/depots/form/:id',
      name: 'tab-0-edit',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: (route) => ({ activeTab: 0, editId: route.params.id })
    },
    {
      path: '/admin/users',
      name: 'tab-1',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: { activeTab: 1 }
    },
    {
      path: '/admin/users/form',
      name: 'tab-1-create',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: { activeTab: 1, create: 1 }
    },
    {
      path: '/admin/users/form/:id',
      name: 'tab-1-edit',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: (route) => ({ activeTab: 1, editId: route.params.id })
    },
    {
      path: '/admin/products',
      name: 'tab-2',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: { activeTab: 2 }
    },
    {
      path: '/admin/products/form',
      name: 'tab-2-create',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: { activeTab: 2, create: 2 }
    },
    {
      path: '/admin/products/form/:id',
      name: 'tab-2-edit',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: (route) => ({ activeTab: 2, editId: route.params.id })
    },
    {
      path: '/admin/product-lists',
      name: 'tab-3',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: { activeTab: 3 }
    },
    {
      path: '/admin/product-lists/form',
      name: 'tab-3-create',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: { activeTab: 3, create: 3 }
    },
    {
      path: '/admin/product-lists/form/:id',
      name: 'tab-3-edit',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: (route) => ({ activeTab: 3, editId: route.params.id })
    },
    {
      path: '/admin/orders',
      name: 'tab-4',
      component: AdminDashboard,
      beforeEnter: requireAdminAuth,
      props: { activeTab: 4 }
    },
    {
      path: '/logout',
      beforeEnter (to, from, next) {
        auth.logout()
        next('/sign-in')
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/Router.js